module.exports = __webpack_public_path__ + "br.svg?eab91a4977926cfa795ddb23f9805032";